import * as React from 'react';
import chiefsAssistantCoachMp4 from "../videos/Chiefs Assistant Coach.mp4";
import ignoresMullenMp4 from "../videos/ignoresMullen.mp4";
import seanPaytonMp4 from "../videos/seanPayton.mp4";
import tiktokMp4 from "../videos/youngCoach.mp4";
import tiktokWebm from "../videos/youngCoach.webm"; // Import the WebM version
import { Carousel } from './Carousel';
import { CarouselItem } from './CarouselItem';
import { YouTubeEmbed } from './YouTubeEmbed';
import './Problem.css';

export function Problem() {
  return (
    <div id="problem">
      <div>
        <h4 className="subTitle problem">The Problem</h4>
      </div>
      <Carousel>
        <CarouselItem playbackMode="event">
          <div className="verticalVideo socialEmbedFrame">
            <YouTubeEmbed
              className='responsiveVideo responsiveVideoVertical'
              videoId="vQm8eBHWIIY"
              title="Kim Mulkey LSU Women's Basketball YouTube Short"
            />
          </div>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <div className="verticalVideo socialEmbedFrame">
            <YouTubeEmbed
              className='responsiveVideo responsiveVideoVertical'
              videoId="Ym_3w-6rjaw"
              title="YouTube Short Ym 3w 6rjaw"
            />
          </div>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <div className="verticalVideo socialEmbedFrame">
            <YouTubeEmbed
              className='responsiveVideo responsiveVideoVertical'
              videoId="ZXV--08d5TQ"
              title="YouTube Short ZXV 08d5TQ"
            />
          </div>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <div className="verticalVideo socialEmbedFrame">
            <YouTubeEmbed
              className='responsiveVideo responsiveVideoVertical'
              videoId="CwyVpFz5zto"
              title="YouTube Short CwyVpFz5zto"
            />
          </div>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <video className='responsiveVideo' controls style={{ background: "black" }}>
            <source src={chiefsAssistantCoachMp4} type='video/mp4' />
            Your browser does not support the video tag.
          </video>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <YouTubeEmbed
            className='responsiveVideo'
            videoId="nnY501c0hPQ"
            title="YouTube video player"
          />
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <div className="verticalVideo socialEmbedFrame">
            <YouTubeEmbed
              className='responsiveVideo responsiveVideoVertical'
              videoId="Fi0CHov0J3Q"
              title="YouTube Short Fi0CHov0J3Q"
            />
          </div>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <div className="verticalVideo socialEmbedFrame">
            <YouTubeEmbed
              className='responsiveVideo responsiveVideoVertical'
              videoId="AP_-ggp_aA0"
              title="YouTube Short AP ggp aA0"
            />
          </div>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <div className="verticalVideo socialEmbedFrame">
            <YouTubeEmbed
              className='responsiveVideo responsiveVideoVertical'
              videoId="d_Pcm5lZ8uQ"
              title="YouTube Short d Pcm5lZ8uQ"
            />
          </div>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <div className="verticalVideo socialEmbedFrame">
            <YouTubeEmbed
              className='responsiveVideo responsiveVideoVertical'
              videoId="7ElVsSHeDBc"
              title="YouTube Short 7ElVsSHeDBc"
            />
          </div>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <div className="verticalVideo socialEmbedFrame">
            <YouTubeEmbed
              className='responsiveVideo responsiveVideoVertical'
              videoId="DsFPkXAq5vI"
              title="YouTube Short DsFPkXAq5vI"
            />
          </div>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <YouTubeEmbed
            className='responsiveVideo'
            videoId="fb54skBOzzc"
            title="John Tortorella NHL timeout calls"
          />
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <YouTubeEmbed
            className='responsiveVideo'
            videoId="oRxRigZMwKM"
            title="YouTube video player"
          />
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <YouTubeEmbed
            className='responsiveVideo'
            videoId="FT7vi91CIjk"
            title="YouTube video player"
          />
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <YouTubeEmbed
            className='responsiveVideo'
            videoId="dDlCa4IoPvE"
            title="YouTube video player"
          />
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <video className='responsiveVideo' controls style={{ background: "black" }}>
            <source src={ignoresMullenMp4} type='video/mp4' />
            Your browser does not support the video tag.
          </video>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <div className="verticalVideo socialEmbedFrame">
            <YouTubeEmbed
              className='responsiveVideo responsiveVideoVertical'
              videoId="ByBLVZAebp0"
              title="YouTube Short ByBLVZAebp0"
            />
          </div>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <YouTubeEmbed
            className='responsiveVideo'
            videoId="kmu5X2sO5rA"
            title="YouTube video kmu5X2sO5rA"
          />
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <video className='responsiveVideo' controls style={{ background: "black" }}>
            <source src={seanPaytonMp4} type='video/mp4' />
            Your browser does not support the video tag.
          </video>
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <YouTubeEmbed
            className='responsiveVideo'
            videoId="b31GA_t6IdY"
            title="YouTube video b31GA t6IdY"
          />
        </CarouselItem>
        <CarouselItem playbackMode="event">
          <div className="verticalVideo">
            <video className='responsiveVideo' controls style={{ background: "black" }}>
              <source src={tiktokMp4} type='video/mp4' />
              <source src={tiktokWebm} type='video/webm' />
              Your browser does not support the video tag.
            </video>
          </div>
        </CarouselItem>
      </Carousel>
    </div>
  );
}
